module.exports = __webpack_public_path__ + "img/logo.de460b98.svg";